// --------------------------------------------------------------
// Created On: 2025-10-29
// Author: Marco Serrano
//
// Last Modified: 2025-12-10
// Modified By: Jonathon Hicke
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Takes in a price and then formats into a string with 2 decimal places ex. 34 -> "34.00"
export default function formatPrice(price: number | null) {
  if (price === null) {
    return "N/A";
  }
  return `$${price.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
